import { GetServerSideProps } from "next";
import { StrapiBecomeSeller } from "~/shared-types";
import { findSingleType } from "~/strapi/api";
import { handleRequestError } from "~/utils/rollbar";
import Richtext from "~/components/Richtext";
import SingleType from "../SingleType";
import { useState } from "react";
import Button from "~/components/Button";

type ServerSideProps = {
  page: StrapiBecomeSeller | null;
};

export const getServerSideProps: GetServerSideProps<ServerSideProps> = async (
  context
) => {
  const page = await findSingleType<StrapiBecomeSeller>("become-seller").catch(
    handleRequestError(context.req, null)
  );

  return {
    props: {
      page,
    },
  };
};

export default function BecomeSellerPage({ page }: ServerSideProps) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) return;
    setLoading(true);
    try {
      await fetch("/api/backroom/bliv-medlem", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, name }),
      });
      setSubmitted(true);
    } catch (e) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  return (
    <SingleType>
      <SingleType.Heading>Bliv en del af vores fællesskab</SingleType.Heading>
      {page?.attributes.content && (
        <SingleType.Content>
          <Richtext content={page.attributes.content} />
        </SingleType.Content>
      )}
      <SingleType.Content className="!mb-4">
        {submitted ? (
          <p className="mt-2">Tak for din interesse i Butik Danmark. Vi kontakter dig snart. 😊</p>
        ) : (
          <div className="flex flex-col gap-3 max-w-sm">
            <input
              type="text"
              placeholder="Dit navn"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="border border-secondary-300 rounded-lg px-4 py-3 text-sm outline-none focus:border-primary-500"
            />
            <input
              type="email"
              placeholder="Din e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border border-secondary-300 rounded-lg px-4 py-3 text-sm outline-none focus:border-primary-500"
            />
            <Button
              type="button"
              variant="primary"
              size="xl"
              className="w-full py-4"
              onClick={handleSubmit}
              disabled={loading || !email || !name}
            >
              {loading ? "Sender..." : "Kontakt mig"}
            </Button>
            <p className="text-sm text-secondary-500 mt-2">
              Læs om vores <a href="/abonnementsbetingelser" className="underline">vilkår for producenter</a> her.
            </p>
          </div>
        )}
      </SingleType.Content>
    </SingleType>
  );
}
